import styled from 'styled-components'

export const Wrapper = styled.div`
  max-height: 9.875rem;
  transition: background 0.2s ease-in-out;

  &:not(:first-child) {
    border-top: 1px solid var(--gray-200);
  }

  &:hover {
    background-color: var(--gray-200);
    border-radius: var(--border-radius);
  }
`

Wrapper.displayName = 'Wrapper'

export const Image = styled.img`
  height: 6rem;
  width: 6rem;
  object-fit: cover;
`

Image.displayName = 'Image'
